import CurrencySymbolStore from './symbols.store';

/**
 * Returns symbol based on uom value exists in CurrencySymbolStore object
 * e.g. 'Mexican Peso' will return '$' OR 'Euro' will return '€'
 * @param currency {string} uom value
 * @returns string
 */
export const getSymbol = (currency: string) => {
  const store = CurrencySymbolStore.get();
  return store[currency] || '$';
};
